<template>
<span>


<!--  <div style="max-height: 70vh;">-->

             <v-progress-linear
                 v-if="messageLoader"
                 indeterminate
                 color="#242f7e"
                 class="mb-0"
                 height="2"
             ></v-progress-linear>


<div
    ref="messageScroller"
    class="message-scroller"
    @scroll="onScroll"
    @wheel="onWheel"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
>
     <v-list  subheader>
                  <v-list-item-group
                     v-for="item in messageList" :key="item.id"
                  >
                    <v-list-item
                        style="border-bottom: 0.5px solid #f1f1f1;"
                        @click.prevent="selectReceiverMessage(item)"
                        link>

                      <v-list-item-avatar>
                        <v-icon large>
                          mdi-account-circle
                        </v-icon>
                      </v-list-item-avatar>


                      <v-list-item-content>


    <v-tooltip max-width="390" color="black" bottom>
      <template v-slot:activator="{ on, attrs }">


                <v-list-item-title v-bind="attrs" v-on="on" style="font-weight: bold;" v-if="item.user_name" v-text="item.user_name"></v-list-item-title>
                        <small class="text-truncate" style="font-weight: bold; color: #676666;" v-if="item.receiver_phone" v-text="item.receiver_phone"></small>
                        <small v-bind="attrs" v-on="on" class="text-truncate" v-if="item.description"  v-text="item.description"></small>
                        <small  class="text-truncate" style="color: #1976d2;" v-if="item.date"  v-text="item.date"></small>


      </template>
      <div>{{item.description}}</div>
    </v-tooltip>



                      </v-list-item-content>


                        <v-list-item-action>


                      </v-list-item-action>

                    </v-list-item>

                  </v-list-item-group>

                </v-list>

    <div v-if="loadFailed" class="load-more-wrap">
      <button
          type="button"
          class="load-more-btn"
          :disabled="messageLoader"
          @click.stop="retryLoad"
      >
        Load more
      </button>
    </div>
</div>



<!--  </div>-->

</span>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import router from "@/Global/router";

export default {
  name: "ReceivedMessages",
  data(){
    return{
      messageLoader:false,
      loadFailed:false,
      hasMoreMessages:true,
      scrollReady:true,
      loadedScrollHeight:0,
      items_per_page: 11,
      page: 1,
      pendingPage: 1,
      touchStartY: 0,
      messageList:[],
    }
  },
  mounted() {
    this.fetchReceivedMessageList()
  },
  methods:{
    ...mapActions(
        [
            "fetchReceivedMessages"
        ]
    ),
    fetchReceivedMessageList(){
      this.messageList = []
      this.page = 1
      this.pendingPage = 1
      this.hasMoreMessages = true
      this.loadFailed = false
      this.scrollReady = true
      this.loadedScrollHeight = 0
      this.messageLoader = false
      this.loadMessagePage(1)
    },
    retryLoad(){
      this.loadFailed = false
      this.messageLoader = false
      this.loadMessagePage(this.pendingPage || 1)
    },
    loadMessagePage(page){
      if (this.messageLoader || !this.hasMoreMessages) {
        return
      }
      this.messageLoader = true
      this.pendingPage = page
      this.fetchReceivedMessages({
        page: page,
        per_page: this.items_per_page,
      })
    },
    onScroll(event) {
      const target = event && event.target ? event.target : null
      this.requestNextPage(target, false)
    },
    onWheel(event) {
      if (!event || event.deltaY <= 0) {
        return
      }
      this.requestNextPage(this.$refs.messageScroller, true)
    },
    onTouchStart(event) {
      const touch = event.touches && event.touches[0]
      this.touchStartY = touch ? touch.clientY : 0
    },
    onTouchMove(event) {
      const touch = event.touches && event.touches[0]
      if (!touch || this.touchStartY - touch.clientY < 12) {
        return
      }
      this.requestNextPage(this.$refs.messageScroller, true)
    },
    requestNextPage(target, fromUserGesture) {
      if (!target || this.messageLoader || !this.hasMoreMessages || this.loadFailed) {
        return
      }
      if (target.clientHeight < 40) {
        return
      }
      const distanceFromBottom = target.scrollHeight - (target.scrollTop + target.clientHeight)
      if (distanceFromBottom > 160) {
        this.scrollReady = true
        return
      }
      if (target.scrollHeight <= this.loadedScrollHeight) {
        return
      }
      if (!fromUserGesture && (target.scrollTop <= 0 || !this.scrollReady)) {
        return
      }
      this.scrollReady = false
      this.loadedScrollHeight = target.scrollHeight
      this.loadMessagePage(this.page + 1)
    },
    fillIfShort() {
      const target = this.$refs.messageScroller
      if (!target || this.messageLoader || !this.hasMoreMessages || this.loadFailed) {
        return
      }
      if (target.clientHeight < 40) {
        return
      }
      if (target.scrollHeight > target.clientHeight + 4) {
        return
      }
      this.loadMessagePage(this.page + 1)
    },
    filterMessageData(data){
      if (!data) {
        return
      }
      let dataObj = Array.isArray(data.data) ? data.data : [];
      let current_page = (data.page * 1);
      if (current_page > 0 && this.pendingPage && current_page !== this.pendingPage) {
        return
      }
      this.page = current_page > 0 ? current_page : this.page;
      this.hasMoreMessages = dataObj.length >= this.items_per_page;
      this.loadFailed = false
      this.messageLoader = false

      let added = 0
      dataObj.forEach(list => {
        let jsn = {
          id: list.number,
          user_name: list.user_name ? list.user_name : "",
          receiver_phone: list.msg_receiver_phone ? list.msg_receiver_phone : "",
          description: list.msg_text ? list.msg_text : "",
          number: list.receiver_id_number ? list.receiver_id_number : "",
          date: list.updated_at ? this.timeAgo(new Date(list.updated_at)) : "",
        }

        const index = this.messageList.findIndex(object => object.id === jsn.id);

        if (index === -1) {
          this.messageList.push(jsn);
          added++
        }

      })

      if (dataObj.length > 0 && added === 0) {
        this.hasMoreMessages = false
      }

      this.$nextTick(() => {
        this.fillIfShort()
      })
    },
    selectReceiverMessage(item){
      router.push({name:'messenger', query: {type:'con', id:item.number, q: (item.receiver_phone).replace('+', ''), rv:item.id }})
    }
  },
  computed:{
    ...mapGetters(
        [
            "getReceivedMessages",
            "getMessageError"
        ]
    )
  },
  watch:{
    getReceivedMessages(data){
      if(data){
        this.filterMessageData(data)
      }
    },
    getMessageError(data){
      if(data && this.messageLoader){
        this.messageLoader = false
        this.loadFailed = true
        this.scrollReady = true
      }
    },

  }
}
</script>

<style scoped>
.message-scroller {
  width: 100%;
  max-height: 620px;
  overflow-y: auto;
}
.load-more-wrap {
  display: flex;
  justify-content: center;
  padding: 12px 0 16px;
}
.load-more-btn {
  border: 1px solid #242f7e;
  background: transparent;
  color: #242f7e;
  border-radius: 999px;
  padding: 6px 16px;
  font-size: 12px;
  cursor: pointer;
}
.load-more-btn:disabled {
  opacity: 0.55;
  cursor: default;
}
</style>